import Layout from '@4c/layout';
import styled from 'astroturf';
import { styles as navbarStyles } from './Navbar';
const AppBanner = /*#__PURE__*/styled(Layout, null, {
  displayName: "AppBanner",
  styles: require("./AppBanner.module.scss"),
  attrs: props => ({ ...props,
    pad: true,
    align: 'center',
    justify: 'center'
  }),
  vars: []
});
export default AppBanner;